export default "__VITE_ASSET__DSAmLySL__"